import { ref } from 'vue'
import { defineStore } from 'pinia'


export const useUiStore = defineStore('ui', () => {
  //ModalUi
  const modalUiId = ref("");
  function setModalUiId (newModalUiId: string) {
    modalUiId.value = newModalUiId
  }


  //Filters
  const resultFilter = ref("")
  function setResultFilter(newFilter: string) {
    resultFilter.value = (resultFilter.value === newFilter) ? "" : newFilter
  }
  const cclDocumentFilter = ref("")
  function setCclDocumentFilter(newFilter: string) {
    cclDocumentFilter.value = (cclDocumentFilter.value === newFilter) ? "" : newFilter
  }  
  const creatorFilter = ref("")
  function setCreatorFilter(newFilter: string) {
    creatorFilter.value = (creatorFilter.value === newFilter) ? "" : newFilter
  }  
  const fetchFilter = ref("")
  function setFetchFilter(newFilter: string) {
    fetchFilter.value = (fetchFilter.value === newFilter) ? "" : newFilter
  }
  const yearFilter = ref("")
  function setYearFilter(newFilter: string) {
    yearFilter.value = (yearFilter.value === newFilter) ? "" : newFilter
  }



  
  //Admin Dashboard
  const adminDashBoardView = ref('dashbPatient');
  const adminDashBoardItem = ref(null);
  function setAdminDashBoardItem (view: string, item: any) {
    adminDashBoardView.value = view
    adminDashBoardItem.value = item      
  }
  function setAdminDashBoardView (view: string) {
    adminDashBoardView.value = view
    adminDashBoardItem.value = null    
  }  
  function clearAdminDashBoard() {
    adminDashBoardView.value = 'dashbPatient'
    adminDashBoardItem.value = null
  }

  //Expression Dashboard
  const dashBoardItemType = ref("");
  const dashBoardItem = ref(null);
  function setDashBoardItem (item: any) {
    dashBoardItemType.value = "SingleItem";
    dashBoardItem.value = item.expression ? item.expression : item;
    modalUiId.value = "mainDashboard";
  }
  function setDashBoardType (itemType: string) {
    dashBoardItemType.value = itemType
    dashBoardItem.value = null
    modalUiId.value = "mainDashboard"
  }  
  function clearDashBoard() {
    dashBoardItemType.value = ""
    dashBoardItem.value = null
    modalUiId.value = ""
  }

  //Middle Column
  const cclTextSelection = ref("");
  function setCclTextSelection (textSelection: string) {
    cclTextSelection.value = textSelection
  }

  //Combined References
  const referenceTab = ref("Sheet");
  function setReferenceTab (tab: string) {
    referenceTab.value = tab
  }

  const currRefSheet = ref(null);
  function setCurrRefSheet (refSheet: any) {
    currRefSheet.value = refSheet
  }

  const referenceSearchKeywords = ref("");    //keywords for searching external references
  function setReferenceSearchKewords (keywords: string) {
    referenceSearchKeywords.value = keywords
  }

  const referenceIFramePath = ref("");    //url for iFrame
  function setReferenceIFramePath (iFramePath: string) {
    referenceIFramePath.value = iFramePath
  }

  const referenceFile = ref(null);
  function setReferenceFile (documentId: string) {
    referenceFile.value = documentId
  }


  //Other
  const loadingScreenText = ref("");    //e.g.patient name
  function setLoadingScreenText (loadingText: string) {
    loadingScreenText.value = loadingText
  }

  const loadingScreenSubText = ref("");    //e.g.patient age
  function setLoadingScreenSubText (loadingSubText: string) {
    loadingScreenSubText.value = loadingSubText
  }

  const fullScreen = ref(false);
  function setFullScreen (bol: boolean) {
    fullScreen.value = bol
  }

  const includeImmediatePayments = ref(false);
  function setIncludeImmediatePayments (bol: boolean) {
    includeImmediatePayments.value = bol;
  }

  //TaskBoxes
  const currTaskBoxId = ref("");
  function setCurrTaskBoxId (taskBoxId: string) {
    currTaskBoxId.value = taskBoxId;
  }

  //Return
  return {
    modalUiId,
    setModalUiId,

    currTaskBoxId,
    setCurrTaskBoxId,

    cclTextSelection,
    setCclTextSelection,

    adminDashBoardView,
    adminDashBoardItem,
    setAdminDashBoardItem,
    setAdminDashBoardView,
    clearAdminDashBoard,


    dashBoardItemType,
    dashBoardItem,
    clearDashBoard,
    setDashBoardItem,
    setDashBoardType,

    currRefSheet,
    setCurrRefSheet,
    referenceIFramePath,
    setReferenceIFramePath,
    referenceSearchKeywords,
    setReferenceSearchKewords,
    referenceTab,
    setReferenceTab,
    referenceFile,
    setReferenceFile,

    loadingScreenText,
    setLoadingScreenText,
    loadingScreenSubText,
    setLoadingScreenSubText,

    fullScreen,
    setFullScreen,
    includeImmediatePayments,
    setIncludeImmediatePayments,

    resultFilter,
    setResultFilter,
    creatorFilter,
    setCreatorFilter,
    cclDocumentFilter,
    setCclDocumentFilter,
    fetchFilter,
    setFetchFilter,
    yearFilter,
    setYearFilter,
  }
})
